import { useTheme } from 'styled-components'
import { LuCheck } from 'react-icons/lu'

import { MergeElementProps } from '@/lib/core/interfaces/common.types'

import { StyledCheckmark } from './Checkmark.styles'

type CheckmarkProps = {
  isActive: boolean
}

export type CheckmakrElementProps = MergeElementProps<'span', CheckmarkProps>

export const CheckmarkComponent = ({ ...props }: CheckmakrElementProps) => {
  const { colors } = useTheme()

  return (
    <StyledCheckmark {...props}>
      <LuCheck color={props.color || colors.active} />
    </StyledCheckmark>
  )
}
